var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2448 1.44629H2.74154C2.16862 1.44629 1.70312 1.91829 1.70312 2.49772V14.9782C1.70312 15.5576 2.16862 16.0296 2.74154 16.0296H15.2448C15.8177 16.0296 16.2865 15.5576 16.2865 14.9782V2.49772C16.2865 1.91829 15.8177 1.44629 15.2448 1.44629ZM6.11068 13.9463H3.94922V6.98665H6.11393V13.9463H6.11068ZM5.02995 6.03613C4.33659 6.03613 3.77669 5.47298 3.77669 4.78288C3.77669 4.09277 4.33659 3.52962 5.02995 3.52962C5.72005 3.52962 6.2832 4.09277 6.2832 4.78288C6.2832 5.47624 5.72331 6.03613 5.02995 6.03613ZM14.2129 13.9463H12.0514V10.5609C12.0514 9.75358 12.0352 8.71517 10.9284 8.71517C9.80208 8.71517 9.62956 9.59408 9.62956 10.5023V13.9463H7.4681V6.98665H9.54167V7.93717H9.57096C9.86068 7.3903 10.5671 6.81413 11.6185 6.81413C13.806 6.81413 14.2129 8.25619 14.2129 10.1312V13.9463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e8530451494ecb3190ffcfba157fe8e0.svg";
export { ForwardRef as ReactComponent };